<miq-number
  [required]="configuration.required"
  [dataType]="configuration.dataType"
  [disabled]="configuration.isDisabled"
  [placeholder]="configuration?.placeholder"
  [format]="configuration.dataType !== 'id'"
  [precision]="configuration?.options?.format"
  [valueSetter]="configuration.valueSetter"
  [(currentValue)]="value"
>
</miq-number>
